// HOOKS
import { createContext } from "react";
import useGetManyTickets from "../../hooks/tickets/useGetMany.ticket";

export const TicketsContext = createContext({
  tickets: [],
  setTickets: () => {},
  getTickets: () => {},
  metaData: {},
  setMetaData: () => {},
  ticketInput: {},
  setTicketInput: () => {},
  query: {},
  setQuery: () => {},
  handleLimitChange: () => {},
  handlePageChange: () => {},
  handleSearch: () => {},
  handleSort: () => {},
  isLoading: false,
  error: null,
  handleChange: () => {},
});

export const TicketsProvider = ({ children }) => {
  const {
    tickets,
    setTickets,
    getTickets,
    metaData,
    setMetaData,
    ticketInput,
    setTicketInput,
    setQuery,
    query,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
    loading: isLoading,
    error,
  } = useGetManyTickets();

  return (
    <TicketsContext.Provider
      value={{
        tickets,
        setTickets,
        getTickets,
        metaData,
        setMetaData,
        ticketInput,
        setTicketInput,
        setQuery,
        query,
        handleLimitChange,
        handlePageChange,
        handleSearch,
        handleSort,
        isLoading,
        error,
        handleChange: () => {},
      }}
    >
      {children}
    </TicketsContext.Provider>
  );
};
